import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
// import IconWrapper from "../components/icon-wrapper/IconWrapper";
import ContactForm from "../components/contact-form/ContactForm";

export default function ContactSection() {
  const { t } = useTranslation();

  return (
    <StyledContactSection>
      <div className="container">
        <div className="contact-section__wrap">
          <div className="contact-section__left">
            <h1 dangerouslySetInnerHTML={{ __html: t("mainContactTitle") }} />
            <p>{t("mainContactText")}</p>
            <h2>{t("mainContactWorkigTimeTitle")}</h2>
            <ul>
              <li
                dangerouslySetInnerHTML={{
                  __html: t("mainContactWorkigTimeDuJu"),
                }}
              />
              <li
                dangerouslySetInnerHTML={{
                  __html: t("mainContactWorkigTimeShan"),
                }}
              />
              <li
                dangerouslySetInnerHTML={{
                  __html: t("mainContactWorkigTimeYak"),
                }}
              />
            </ul>
          </div>
          <div className="contact-section__right">
            <ContactForm />
          </div>
        </div>
      </div>
    </StyledContactSection>
  );
}

const StyledContactSection = styled.section`
  background-color: var(--dark-blue);
  padding: 140px 0;

  .contact-section {
    &__wrap {
      display: grid;
      grid-template-columns: auto 600px;
      gap: 100px;
    }

    &__left {
      h1 {
        color: var(--white);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 32px;

        span {
          color: var(--extra-light-blue);
        }
      }

      p {
        color: var(--white);
        font-size: var(--fs-body-lg);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body-lg);
        text-align: left;
        margin-bottom: 120px;
      }

      h2 {
        color: var(--white);
        font-size: var(--fs-card-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: 1.35;
        margin-bottom: 18px;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 12px;

        li {
          color: var(--white);
          font-size: var(--fs-body);
          font-style: normal;
          font-weight: var(--fw-medium);
          line-height: var(--lh-body);
        }
      }

      
    }
  }
`;
